import { z } from "zod";

export const allowedExtensionsResponseSchema = z.object({
  extensions: z.array(z.string()),
});

export const allowedPageSizesResponseSchema = z.object({
  defaultPageSize: z.number().int(),
  allowedPageSizes: z.array(z.number().int()),
});

export const ruleCategoriesResponseSchema = z.object({
  categories: z.array(z.string()),
});
